export const RETRIABLE_ERRORS = [
  // Bad Gateway - The server was acting as a gateway or proxy and received an invalid response from the upstream server.
  502, // Request Timeout - The client did not produce a request within the time that the server was prepared to wait. The client MAY repeat the request without modifications at any later time.
  408,
]
export const RETRY_OPTIONS = {
  retries: 5,
  factor: 2,
  minTimeout: 1000,
  maxTimeout: 30000,
  randomize: true,
}
export const JSON_HEADERS = {
  Accept: 'application/json',
}
